import { flattenReduxFormProps } from 'decorators';
import { Textarea } from 'components/core/Textarea';

export default flattenReduxFormProps(Textarea);
